import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export const SUBMISSION_DEADLINE_NOTICE_KEY = 'showSubmissionDeadlineNotice';

const SubmissionDeadlineNotice = () => {
  const [open, setOpen] = useState(
    () => sessionStorage.getItem(SUBMISSION_DEADLINE_NOTICE_KEY) === 'true'
  );

  const handleClose = () => {
    sessionStorage.removeItem(SUBMISSION_DEADLINE_NOTICE_KEY);
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="submission-deadline-notice-title">
      <DialogTitle id="submission-deadline-notice-title">【要確認！】</DialogTitle>
      <DialogContent>
        <p>
          各種届出の申請期限が過ぎております。<br />
          申請いただく際は各届出の窓口となる運営事務局および協力会社へお問い合わせの上、承認された場合のみEX Linkからご提出ください。
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmissionDeadlineNotice;
